<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getProductName } from '@shopware/helpers'

interface ProductListItemImageProps {
    product: Schemas['Product']
    lazy?: boolean
}

withDefaults(defineProps<ProductListItemImageProps>(), {
    lazy: true
})
</script>

<template>
    <FoundationImage
        v-if="product.cover?.media?.url"
        :src="product.cover?.media?.url"
        :alt="getProductName({ product }) || ''"
        width="80"
        height="80"
        fit="fit"
        class="w-20 h-20 object-contain"
        loading="lazy"
    />

    <div v-else class="w-20 h-20 object-contain flex flex-col justify-center items-center bg-base-300 overflow-hidden text-base-500">
        <FoundationIcon name="image" size="xl" />
    </div>
</template>
